import React, { useEffect, useState } from "react";
import Colors from "../../../../../stories/assets/Colors";
import Fonts from "../../../../../stories/assets/Fonts";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import classes from "./AddAQuestion.module.css";
import { Input } from "../../../../../stories/Input/Input";
import { Button } from "../../../../../stories/Button/Button";
import { DropDown } from "../../../../../stories/DropDown/DropDown";
import { TextArea } from "../../../../../stories/TextArea/TextArea";

export default function AddQuestionModal({
  show,
  setShow,
  onAdd,
  data,
  isEditing,
}) {
  const [question, setQuestion] = useState(data?.question);
  const [answer, setAnswer] = useState(data?.answer);

  // useEffect(() => {
  //   setQuestion(data ? data.question : null);
  //   setAnswer(data ? data.answer : null);
  // }, [data]);
  return (
    <ModalSkeleton
      show={show}
      setShow={setShow}
      hideHeaderBorder
      headerStyles={{ marginBottom: "0px", paddingBottom: "24px" }}
      borderRadius={"20px"}
      footerStyles={{ padding: "0px", margin: "0px" }}
      modalClass={classes.modal}
      header={
        <h4
          style={{
            ...Fonts.h4,
            fontSize: "26px",
            color: Colors.neutralShadesOfNero,
          }}
        >
          Add a question
        </h4>
      }
      footer={
        <div className={classes.footerBtns}>
          <Button
            label={"Cancel"}
            primary={false}
            size={"Large"}
            customStyle={{
              ...Fonts.b2,
              lineHeight: "20px",
              width: "95px",
              marginRight: "48px",
              backgroundColor: Colors.white,
              border: "none",
            }}
            onClick={() => setShow(false)}
          />
          <Button
            disabled={!question || !answer}
            label={"Add"}
            primary={true}
            size={"Large"}
            customStyle={{
              width: "120px",
            }}
            onClick={() => {
              const newData = {
                _id: isEditing ? data?._id : Math.floor(Math.random() * 1000),
                question: question?.label,
                answer,
              };
              onAdd(newData);
              setQuestion(null);
              setAnswer(null);
              setShow(false);
            }}
          />
        </div>
      }
    >
      <div className={classes.modalContent}>
        <div className={classes.mb24}>
          <DropDown
            state={question}
            placeholder=""
            setter={setQuestion}
            options={[
              {
                label: "Are there any other fees?",
                value: "Are there any other fees?",
              },
            ]}
            customStyle={{ width: "100%" }}
          />
        </div>
        <div className={classes.mb24}>
          <TextArea label={"Answer"} setter={setAnswer} state={answer} />
        </div>
      </div>
    </ModalSkeleton>
  );
}
